import { useCallback } from 'react';
import type { TFunction } from 'i18next';

import {
  useMeetingConfirm,
  type MeetingConfirmOptions,
} from '@/common/components/meeting/MeetingConfirm';

export function studentExamAbortConfirmBodyKey(
  requiresEvaluation: boolean,
  committed: boolean,
): string {
  if (!requiresEvaluation) return 'oralExam.student.abort.confirmBodyPractice';
  if (committed) return 'oralExam.student.abort.confirmBodyCommitted';
  return 'oralExam.student.abort.confirmBody';
}

export function studentExamAbortConfirmOptions(
  t: TFunction,
  requiresEvaluation: boolean,
  committed: boolean,
): MeetingConfirmOptions {
  return {
    title: t('oralExam.student.abort.title'),
    message: t(studentExamAbortConfirmBodyKey(requiresEvaluation, committed)),
    confirmLabel: t('oralExam.student.abort.confirm'),
    cancelLabel: t('oralExam.student.abort.cancel'),
    destructive: true,
    overlayTestID: 'student-exam-abort-dialog',
    messageTestID: 'student-exam-abort-dialog-body',
    cancelTestID: 'student-exam-abort-cancel',
    confirmTestID: 'student-exam-abort-confirm',
  };
}

/**
 * Abort confirm for in-room student chrome. Uses MeetingConfirm so LiveKit
 * cannot hide the dialog (inline AlertDialog was the z-index trap).
 */
export function useStudentExamAbortConfirm() {
  const { confirm } = useMeetingConfirm();
  return useCallback((
    t: TFunction,
    requiresEvaluation: boolean,
    committed: boolean,
  ) => confirm(studentExamAbortConfirmOptions(t, requiresEvaluation, committed)), [confirm]);
}
